<template>
    <div class="md:max-w-sm mx-auto" v-if="employee">

        <image-crop ref="imageCrop"
                    :image="imageToCrop"
                    @crop="onProfileImageCrop"
                    @delete="onProfileImageDelete"
                    @change="uploadFile"
                    @cancel="resetProfileImage"
                    :showDelete="isProfileImage"
        ></image-crop>

        <input ref="fileUpload" type="file" accept="image/*" class="hidden" @change="processFile">

        <div
            class="profile-header mobile-header fixed pin-t border-b-1 border-grey-darker w-full md:max-w-sm z-30">
            <div class="p-6 relative">
                <div class="max-w-sm mx-auto flex items-center justify-center">
                    <div class="w-auto items-start max-w-sm">
                        <div
                            class="w-24 h-24 items-center cursor-pointer bg-profile-image-edit relative rounded"
                            @click="chooseFile">
                            <div class="w-full h-full overflow-hidden relative rounded z-20 bg-blue">
                                <img v-if="profileImage" :src="profileImage"
                                     :alt="employee.first_name + 's Profile Image'">
                                <div
                                    class="text-blue font-bold text-center invisible text-lg w-full profile-image-edit-caption">
                                    {{ isProfileImage ? 'Update Picture' : 'Upload Picture' }}
                                </div>
                            </div>
                            <div class="border border-white rounded absolute w-full h-full z-10"
                                 style="top: 0; left:0; transform: translateX(-10px) translateY(10px);"></div>
                        </div>
                    </div>
                    <div class="flex flex-col text-left ml-4 overflow-hidden">
                        <h2 class="text-base md:text-xl m-0 mb-0 font-bold font-heading uppercase text-white truncate">
                            {{ employee.first_name }} {{ employee.last_name }}
                        </h2>
                        <h3 v-if="employee.position !== null"
                            class="text-sm md:text-sm m-0 font-medium font-heading uppercase text-white truncate">
                            {{ employee.position.join(' – ') }}
                        </h3>
                        <h3 class="text-sm md:text-sm m-0 font-medium font-heading uppercase text-white truncate">
                            {{ employee.location }}
                        </h3>
                        <!--<h3 class="text-sm md:text-sm m-0 font-medium font-heading uppercase text-blue truncate">
                            {{employee.employer}}
                        </h3>-->
                    </div>
                </div>
            </div>
        </div>

        <div class="flex items-center justify-center mt-32 pt-10 md:mt-4 mb-1" v-if="apps.length">
            <div class="w-full max-w-sm flex flex-wrap lg:flex-wrap mx-auto justify-center -mx-4" v-if="apps.length">
                <app-icon
                    v-for="item in sortedMenuItems"
                    :key="item.label"
                    :route="item.route"
                    :click="item.click"
                    :label="trans(item.trans)"
                    :icon="item.icon"
                    :badge="item.badge"
                >
                </app-icon>
            </div>
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex'
import ImageCrop from '@/components/ImageCrop.vue'
import HasSortedMenuItems from "../mixins/HasSortedMenuItems";

export default {
    mixins: [HasSortedMenuItems],

    components: {
        ImageCrop,
    },

    data() {
        return {
            documents: [],
            profileImage: null,
            imageToCrop: null,
            hasProfileImage: null,
        }
    },

    computed: {
        ...mapState(['employee', 'apps']),

        expiredDocuments() {
            return this.documents
                .filter((document) => (document.status === 'missing' || document.status === 'expired'))
                .length;
        },

        isProfileImage() {
            return this.hasProfileImage;
        },
    },

    created() {
        if (this.$route.query.page) {
            this.$router.push('/' + this.$route.query.page)
        }

        this.$api('hr').get('employee/documents')
            .then(({data}) => {
                this.documents = data.data;
            });

        this.loadProfileImage();
    },

    methods: {
        chooseFile() {
            this.$refs.imageCrop.open();
        },

        loadProfileImage() {
            this.$api('hr')
                .get('employee/profile-image', {
                    responseType: 'blob',
                })
                .then((response) => {
                    this.hasProfileImage = response.headers.expires === 'yes';
                    let data = response.data;
                    let reader = new FileReader();
                    reader.readAsDataURL(data);
                    reader.onload = e => {
                        this.profileImage = e.target.result;
                        this.imageToCrop = e.target.result;
                    };
                });
        },

        uploadFile() {
            this.$refs.fileUpload.click();
        },

        processFile(event) {
            let files = event.target.files;
            if (files.length) {
                let reader = new FileReader();
                reader.onload = e => {
                    this.imageToCrop = e.target.result;
                    this.$refs.fileUpload.value = null;
                    this.$refs.imageCrop.open();
                };
                reader.readAsDataURL(files[0]);
            }
        },

        onProfileImageCrop(image) {
            this.clearProfileImage();
            let data = new FormData();
            data.append('profile_image', image);
            this.$api('hr').post('employee/profile-image', data)
                .then(() => {
                    this.loadProfileImage();
                    this.$noty.success('Profile image uploaded.');
                })
                .catch(({response}) => {
                    this.$noty.error(response.data.message)
                })
        },

        onProfileImageDelete() {
            this.clearProfileImage();
            this.$api('hr').delete('employee/profile-image')
                .then(() => {
                    this.$refs.imageCrop.close();
                    this.loadProfileImage();
                    this.$noty.success('Profile image deleted.');
                })
                .catch(({response}) => {
                    this.loadProfileImage();
                    this.$noty.error(response.data.message)
                })
        },

        resetProfileImage() {
            this.imageToCrop = this.profileImage;
        },

        clearProfileImage() {
            this.profileImage = null;
            this.imageToCrop = null;
        },
    }
}
</script>

<style>
/* Make the badge float in the top right corner of the button */
.button-badge {
    background-color: #fa3e3e;
    border-radius: 25px;
    color: white;

    font-size: 18px;
    width: 30px;
    height: 30px;

    position: absolute;
    top: 0;
    right: 0;
    padding: 5px 1px;
    margin: -10px -10px 0px 0px;
    text-align: center;
}

.profile-image-edit-caption {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
}

.bg-profile-image-edit:hover img {
    opacity: 0.25;
    transition: opacity 0.25s;
}

.bg-profile-image-edit:hover .profile-image-edit-caption {
    visibility: visible;
}

.profile-line {
    top: 6.9rem;
}

@media (max-width: 768px) {
    .mobile-header {
        background: url('../assets/gradients/1.jpg');
        background-size: cover;
    }
}
</style>
